import { createContext } from "react";
import { ARSContextState, IARSContext } from "./interface";

export const arsContextInitialState: ARSContextState = {
  // Read-only reference data
  variables: [],
  comparators: [],

  // Editable/sharable lists
  analysisSets: {},
  dataSubsets: {},
  groupingFactors: {},

  // UI state
  uiRequestStatus: {
    requesting: false,
    error: false,
  },
  changed: false,

  // Undo/redo state
  patches: [],
  ixPatch: -1,
};

export const ARSContext = createContext<IARSContext>({
  state: arsContextInitialState,
  dispatch:
    // istanbul ignore next
    () => {},
});
